export default {
  paper: {
    borderRadius: '1vw',
    maxWidth: 'none!important',
  },
};
